<template>
    <div>
        <h3>あらすじを書く</h3>
        <div>
            <p>
                長編作品には、最大３話までのあらすじを１４０文字以内で記述することができます。
                これらのあらすじは目次ページ、ポータルの小説カード（クリック時にポップアップ）に表示されます。
                冒頭３話分の簡単なあらすじが記述されていることで、その作品が初見の読者にリーチする可能性が高くなります。
            </p>
            <p>
                あらすじは基本的に冒頭３話を推奨しますが、機能的には最初の３話でなくても構いません。
                例えば第１話が非常に短いプロローグで第２話から本編が始まる場合は、第２話、第３話、第４話のあらすじを書くことができます。
                また、冒頭部分の各エピソードが短く３話区切り担っている場合は、第１話、第４話、第７話のあらすじを書くことで、読者が大まかな流れをつかむことができます。
            </p>
            <img src="/img/help/novel/41.jpg" alt="あらすじ" class="img-thumbnail mb-3">
            <h4>あらすじを書く</h4>
            <p>
                マイページ＞小説管理＞本文一覧のサイドバーの「あらすじ」ボタンからあらすじ編集画面を開きます。
                あらすじを書きたいエピソードの編集ボタンをクリックして、140文字以内であらすじを記述してください。
            </p>
            <img src="/img/help/novel/42.jpg" alt="あらすじ編集" class="img-thumbnail mb-3">
            <p>
                あらすじには背景画像をつけることができます。
            </p>
            <p>
                3MB以内の画像ファイルをアップロードすることで、適切なサイズに縮小してあらすじパネルの背景として適用します。
                あらすじ文字の可読性を損なわないように調整されるので、画像を加工する必要はありません。
            </p>
            <p>
                アップロードできる画像の総容量にはユーザー単位で制限があります。
                制限値はアップロードボタンの下部に表示されます。
                制限値はユーザー様の活動状況に応じて拡張されることがあります。
            </p>
            <h4>あらすじの表示</h4>
            <p>
                あらすじは小説の目次ページ及びポータルの小説カードに表示されます。
                未公開エピソードのあらすじはエピソードが公開されるまで表示されません。
            </p>
            <p>
                エピソードの流れを客観的に短くまとめたあらすじが記載されていることで、
                初見の新規読者が作品を読み始めるためのハードルを格段に下げることが期待できます。
            </p>
            <img src="/img/help/novel/43.jpg" alt="あらすじ表示" class="img-thumbnail mb-3">
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "あらすじを書く | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>